import React from 'react'
import Image from 'next/image'
import { Box, Typography } from '@mui/material'
import { getStyles } from '@utils/styles'
import { ChipData } from '../Chip'
import defaultStyles from './styles'

export type CareerPageBannerData = {
  heading: string
  description?: string
  chipsData?: ChipData[]
}

type CareerPageBannerProps = CareerPageBannerData

export function CareerPageBanner({
  heading,
  description,
  chipsData,
}: CareerPageBannerProps) {
  const styles = getStyles(defaultStyles)

  return (
    <Box {...styles('banner')}>
      <Typography variant="h2.500">{heading}</Typography>
      {description && <Typography>{description}</Typography>}
      {!!chipsData?.length && (
        <Box {...styles('chipWrapper')}>
          {chipsData.map(({ iconData, label }, idx) => (
            <Box key={idx} {...styles('chip')}>
              {iconData && <Image width={20} height={20} {...iconData} />}
              <Typography variant="body2.500" color="text.secondary">
                {label}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}
